module.exports = {"StatusCode":200,"Payload":[{"data":{"alias":"my-website","_id":"some-id","tier":"Free","name":"name-here","pages":["some-page-id","some-page-id-2"],"drafts":[],"templates":["some-tpl-id","some-tpl-id-2"],"recycled":[],"dynamic":{}}}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/getRawWebsite.json
// module id = 5cIy
// module chunks = 0